'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const OfferLifestyleImage = require('../.././modules/shared/views/offer/offer-lifestyle-image');
const MerchantLogoImage = require('../.././modules/shared/views/merchants/merchant-logo-image');

function getOfferImageSize(isTouch, innerWidth) {
  if (isTouch) {
    return innerWidth ? [`w_${innerWidth},h_136`] : ['w_400,h_136'];
  }

  return ['w_868,h_289'];
}

function getLogoImageSize(isTouch) {
  if (isTouch) {
    return ['w_68,h_68'];
  }

  return ['w_86,h_86'];
}

function Slide({
  routes,
  item,
  className,
  sizes = {},
  child = null,
  tag = 'a',
  lazy = false,
}) {
  if (!item) return null;

  const { isExclusive } = item;

  const altText = `${item.merchantName} - ${item.offerCallout}`;
  const advertUrl = item.merchantSlug
    ? routes.merchant.show.replace('{merchantSlug}', item.merchantSlug)
    : item.destination;

  return h(
    `${tag}.${className}`,
    {
      href: advertUrl,
      target: !item.merchantSlug && '_blank',
      title: item.offerTitle,
    },
    [
      h(
        '.logo',
        OfferLifestyleImage({
          alt: altText,
          data: item.media,
          size: sizes.offer,
          lazyload: lazy,
        })
      ),
      MerchantLogoImage({
        className: 'merchant-logo',
        data: item.media,
        alt: altText,
        size: sizes.logo,
        lazyload: lazy,
      }),
      h(WithI18n, {}, i18n =>
        h(`.description.should-truncate${isExclusive ? '.icon-logo-g' : ''}`, [
          isExclusive && h('strong', i18n.t('js.modules.shared.Exclusive')),
          item.offerTitle || item.description,
        ])
      ),
      child,
    ]
  );
}

module.exports = Slide;
module.exports.getOfferImageSize = getOfferImageSize;
module.exports.getLogoImageSize = getLogoImageSize;
